/* ==========================================================================
   Tooltip > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'Tooltip',
    init: true,
    start: true,
    css: {},
    type: {},
    offset: [0, 8]
};

module.exports = () => config;
